import React from "react";
import styled from "styled-components";
import * as Icons from "react-icons/bi";
import { t } from "../utils/i18n";
import logo from "../assets/images/logo.png";
import NavigationItem from "./NavigationItem";
import ThemeSwitch from "./ThemeSwitch";

export default function Navigation() {
  return (
    <Container>
      <LogoContainer>
        <Logo src={logo} alt="Logo" />
      </LogoContainer>
      <Links>
        <NavigationItem
          to="/"
          label={t("navigation.home")}
          Icon={Icons.BiHome}
        />
        <NavigationItem
          to="/about"
          label={t("navigation.about")}
          Icon={Icons.BiUserCircle}
        />
        <NavigationItem
          to="/skills"
          label={t("navigation.skills")}
          Icon={Icons.BiNetworkChart}
        />
        <NavigationItem
          to="/portfolio"
          label={t("navigation.portfolio")}
          Icon={Icons.BiTerminal}
        />
        <NavigationItem
          to="/contact"
          label={t("navigation.contact")}
          Icon={Icons.BiEnvelope}
        />
      </Links>
      <ThemeSwitch />
    </Container>
  );
}

const Container = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  background: ${({ theme }) => theme.navigationBackground};
  width: 60px;
  justify-content: space-between;
`;

const Links = styled.div`
  display: flex;
  flex-direction: column;
`;

const LogoContainer = styled.div`
  height: 70px;
  background: ${({ theme }) => theme.navigationLogoBackground};
  display: flex;
  align-items: center;
  justify-content: center;
`;

const Logo = styled.img`
  width: 55px;
`;
